// extracted by mini-css-extract-plugin
module.exports = {"container":"subscriptions_container__sPx_S","list-subscriptions":"subscriptions_list-subscriptions__1YZIr","list-item":"subscriptions_list-item__4itJE"};